/* eslint-disable react/prop-types */

import { GOOGLE_MAP_STATUS } from '../../../utils/constants';
import locationIcon from '../../../common/images/revamp/icon/location.svg';
import notFoundImage from '../../../common/images/revamp/images/search-not-found.svg';
import { handleFormatingAddress, isEmptyData } from '../../../utils/helper';
import { getGeocode, getLatLng } from 'use-places-autocomplete';
import { useDispatch } from 'react-redux';
import { setUser } from '../../../store/reducers/user';

const Result = (props) => {
	const { data, status, onClose } = props;
	const dispatch = useDispatch();

	const handleClick = async (data = null) => {
		if (isEmptyData(data?.place_id)) return;
		await getGeocode({ placeId: data?.place_id }).then((results) => {
			const result = results[0];
			const { lat, lng } = getLatLng(result);
			const formated = handleFormatingAddress({
				lat,
				lng,
				formatted_address: result?.formatted_address || '',
				address_components: result?.address_components || {},
				detail: result?.address_detail ?? null,
			});
			dispatch(
				setUser({
					addressName: null,
					address: formated?.address,
					latitude: Number(formated?.lat),
					longitude: Number(formated?.lng),
					country: formated?.country,
					state: formated?.state,
					city: formated?.city,
					village: formated?.village,
					district: formated?.district,
					postalCode: formated?.postalCode ?? '',
					detail: null,
				}),
			);
		});
		onClose();
	};

	return (
		<>
			<div className='px-4'>
				<div className='space-y-2.5'>
					{data?.map((item, index) => (
						<div key={index} className='[&:not(:last-child)]:border-b border-solid border-[var(--pin-ball)] p-2.5 flex items-center gap-2.5' onClick={() => handleClick(item)}>
							<img src={locationIcon} alt='location' className='w-4.5 h-4.5' />
							<div className='space-y-0.5'>
								<p className='text-[var(--dark-gray)] text-sm font-semibold'>{item.structured_formatting.main_text}</p>
								{item.structured_formatting.secondary_text && <p className='text-[var(--dark-gray)] text-xxs'>{item.structured_formatting.secondary_text}</p>}
							</div>
						</div>
					))}
					{status === GOOGLE_MAP_STATUS.ZERO_RESULTS && (
						<div className='py-7 px-4'>
							<img src={notFoundImage} alt='not-found' className='h-[160px] mx-auto mb-4' />

							<p className='text-[var(--dark-gray)] font-semibold text-sm px-6 mb-1.5 text-center'>Hmm, tidak ada lokasi yang ditemukan</p>
							<p className='text-[var(--dark-gray)] text-xxs text-center px-14'>Kami tidak dapat menemukan apa yang Anda cari. Bagaimana kalau mencoba sesuatu yang lain??</p>
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default Result;
